import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Card,
  Pagination,
  Offcanvas,
  Form,
} from "react-bootstrap";
import { FiFilter } from "react-icons/fi";
import "../../userreport.css";
import { IoIosArrowForward, IoMdEye } from "react-icons/io";
import { useNavigate, Link } from "react-router-dom";
import { getUser } from "../../store/slices/user";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

function getInitials(name = "") {
  return name
    .split(" ")
    .slice(0, 2)
    .map((n) => n[0]?.toUpperCase() || "")
    .join("");
}

export default function CandidateList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [limit] = useState(20);
  const [searchParams, setSearchParams] = useSearchParams();


  const getFiltersFromUrl = () => ({
    status: searchParams.get("status") || "",
    aadhaarVerified: searchParams.get("aadhaarVerified") || "",
    subscription: searchParams.get("subscription") || "",
    gender: searchParams.get("gender") || "",
    fromDate: searchParams.get("fromDate") || "",
    toDate: searchParams.get("toDate") || "",
    search: searchParams.get("search") || "",
  });

  const [filters, setFilters] = useState(getFiltersFromUrl);
  const [appliedFilters, setAppliedFilters] = useState(getFiltersFromUrl);

  const currentPage = Number(searchParams.get("page")) || 1;
  const filter = searchParams.get("filter") || "All";
  const search = searchParams.get("search") || "";


  const updateParams = ({
    page = currentPage,
    filterValue = filter,
    searchValue = search,
    filterData = appliedFilters,
  }) => {
    const params = {};

    params.page = page;

    if (filterValue && filterValue !== "All") {
      params.filter = filterValue;
    }

    if (filterData.status) {
      params.status = filterData.status;
    }

    if (filterData.aadhaarVerified !== "") {
      params.aadhaarVerified = filterData.aadhaarVerified;
    }

    if (filterData.subscription) {
      params.subscription = filterData.subscription;
    }

    if (filterData.gender) {
      params.gender = filterData.gender;
    }

    if (filterData.fromDate) {
      params.fromDate = filterData.fromDate;
    }

    if (filterData.toDate) {
      params.toDate = filterData.toDate;
    }

    if (searchValue.trim()) {
      params.search = searchValue.trim();
    }

    setSearchParams(params);
  };
  const changePage = (page) => {
    updateParams({ page });
  };

  const [meta, setMeta] = useState({ total: 0, page: 1, limit: 10 });
  const [statsData, setStatsData] = useState({
    totalUsers: 0,
    activeUsers: 0,
    inactiveUsers: 0,
    verifiedUsers: 0,
    pendingUsers: 0,
    blockedUsers: 0,
  });

  const { userlist = [] } = useSelector((state) => state.user);

  useEffect(() => {
    const params = {
      page: currentPage,
      limit,
    };

    const searchText = appliedFilters.search || search;

    if (searchText.trim()) {
      params.search = searchText.trim();
    }
    if (appliedFilters.gender)
      params.gender = appliedFilters.gender;

    if (appliedFilters.aadhaarVerified !== "")
      params.aadhaarVerified = appliedFilters.aadhaarVerified;


    if (appliedFilters.subscription)
      params.subscription = appliedFilters.subscription;

    if (appliedFilters.fromDate)
      params.fromDate = appliedFilters.fromDate;

    if (appliedFilters.toDate)
      params.toDate = appliedFilters.toDate;

    switch (appliedFilters.status) {
      case "Active":
        params.isActive = true;
        break;

      case "Inactive":
        params.isActive = false;
        break;

      case "Verified":
        params.profileVerified = true;
        break;

      case "Pending":
        params.profileVerified = false;
        break;

      default:
        break;
    }

    dispatch(getUser(params)).then((res) => {
      const payload = res.payload || {};

      setMeta({
        total: payload.total || 0,
        page: payload.page || 1,
        limit: payload.limit || limit,
      });

      setStatsData(
        payload.stats || {
          totalUsers: 0,
          activeUsers: 0,
          inactiveUsers: 0,
          verifiedUsers: 0,
          pendingUsers: 0,
          blockedUsers: 0,
        }
      );
    });
  }, [dispatch, currentPage, limit, search, appliedFilters]);

  const total = meta.total;
  const totalPages = Math.max(1, Math.ceil(total / limit));



  const stats = [
    {
      title: "Total Users",
      value: statsData.totalUsers,
      iconClass: "icon-total",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
    },
    {
      title: "Active",
      value: statsData.activeUsers,
      iconClass: "icon-active",
      sub: "of total",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
      ),
    },
    {
      title: "Verified",
      value: statsData.verifiedUsers,
      iconClass: "icon-verified",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      ),
    },
    {
      title: "Pending",
      value: statsData.pendingUsers,
      iconClass: "icon-pending",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      ),
    },
    {
      title: "Suspended",
      value: statsData.blockedUsers,
      iconClass: "icon-suspended",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
      ),
    },
  ];


  const formatDate = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleView = (candidate) => {
    navigate(`/admin/candidatedetails/${candidate._id}`, { state: candidate });
  };

  return (
    <>
      <div className="breadcrumb-bar mb-4">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator">
            <IoIosArrowForward size={15} />
          </span>
          <span className="breadcrumb-link active">Candidates</span>
        </div>
      </div>

      <Container className="cl-container">
        {/* Page heading */}
        <div className="cl-page-header">
          <div>
            <h1 className="cl-page-title">Candidates</h1>
          </div>
        </div>

        {/* Stat cards */}
        <Row className="g-3 mb-4">
          {stats.map((s, i) => (
            <Col xl lg={4} md={4} sm={6} xs={12} key={i}>
              <div className="cl-stat-card">
                <div>
                  <div className="cl-stat-label">{s.title}</div>
                  <div className="cl-stat-value">{s.value}</div>
                </div>
                <div className={`cl-stat-icon ${s.iconClass}`}>{s.icon}</div>
              </div>
            </Col>
          ))}
        </Row>

        <Card className="cl-table-card">
          <div className="cl-toolbar d-flex justify-content-end align-items-center">
            <button
              style={{ height: "40px" }} className="cancel-btn"
              onClick={() => setShowFilter(true)}
            >
              <FiFilter className="me-1" />
              Filters
            </button>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <Table className="cl-table align-middle">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Aadhaar Status</th>

                  <th>Profile</th>
                  <th>Joined</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {userlist?.length ? (
                  userlist.map((u, index) => (
                    <tr key={u._id}>
                      <td className="cl-row-num">
                        {String((currentPage - 1) * limit + index + 1).padStart(2, "0")}
                      </td>

                      <td>
                        <div className="cl-candidate-info">
                          <div
                            className={`cl-avatar ${u.gender?.toLowerCase() === "female"
                              ? "cl-avatar--f"
                              : "cl-avatar--m"
                              }`}
                          >
                            {getInitials(u.name)}
                          </div>

                          <div>
                            <div className="cl-cand-name">{u.name || "-"}</div>
                            <div className="cl-cand-meta">
                              <span className="cl-cand-id">
                                {u._id?.slice(-8)?.toUpperCase()}
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <span
                          className={`cl-badge cl-badge--${u.gender?.toLowerCase() === "female" ? "female" : "male"
                            }`}
                        >
                          {u.gender || "-"}
                        </span>
                      </td>

                      <td className="cl-phone">{u.mobileNumber || "-"}</td>

                      <td className="cl-phone">{u.email || "-"}</td>

                      <td>
                        <span
                          className={`cl-badge ${u.aadhaarVerified
                            ? "cl-badge--active"
                            : "cl-badge--inactive"
                            }`}
                        >
                          <span className="cl-badge-dot" />
                          {u.aadhaarVerified ? "Verified" : "Unverified"}
                        </span>
                      </td>

                      <td>
                        <span
                          className={`cl-badge ${u.profileVerified
                            ? "cl-badge--verified"
                            : "cl-badge--unverified"
                            }`}
                        >
                          {u.profileVerified ? "Verified" : "Unverified"}
                        </span>
                      </td>

                      <td className="cl-date">
                        {formatDate(u.createdAt)}
                      </td>

                      <td>
                        <div className="cl-actions">
                          <button
                            className="cl-act-btn cl-act-btn--view"
                            onClick={() => handleView(u)}
                            title="View"
                          >
                            <IoMdEye />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={9} className="cl-empty text-center py-4">
                      No candidates found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          {/* Footer / Pagination */}
          <div className="cl-table-footer">
            <span className="cl-pagination-info">
              Showing {total === 0 ? 0 : (currentPage - 1) * limit + 1}–
              {Math.min(currentPage * limit, total)} of {total} &nbsp;·&nbsp;
              Page {currentPage} of {totalPages}
            </span>
            <Pagination className="cl-pagination">
              <Pagination.Prev
                onClick={() => changePage(currentPage - 1)}
                disabled={currentPage === 1}
              />


              {[...Array(totalPages)].map((_, i) => (
                <Pagination.Item
                  key={i}
                  active={i + 1 === currentPage}
                  onClick={() => changePage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => changePage(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </Card>
        <Offcanvas
          show={showFilter}
          onHide={() => setShowFilter(false)}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Filter Candidates</Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <Form.Group className="mb-3">
              <Form.Label>Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Name, Mobile, Email..."
                value={filters.search}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    search: e.target.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={filters.status}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    status: e.target.value,
                  })
                }
              >
                <option value="">All</option>
                <option>Active</option>
                <option>Inactive</option>
                <option>Verified</option>
                <option>Pending</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Aadhaar</Form.Label>
              <Form.Select
                value={filters.aadhaarVerified}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    aadhaarVerified: e.target.value,
                  })
                }
              >
                <option value="">All</option>
                <option value="true">Verified</option>
                <option value="false">Unverified</option>
              </Form.Select>
            </Form.Group>



            <Form.Group className="mb-3">
              <Form.Label>Subscription</Form.Label>
              <Form.Select
                value={filters.subscription}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    subscription: e.target.value,
                  })
                }
              >
                <option value="">All</option>
                <option value="active">Active</option>
                <option value="expired">Expired</option>
                <option value="none">No Subscription</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Gender</Form.Label>
              <Form.Select
                value={filters.gender}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    gender: e.target.value,
                  })
                }
              >
                <option value="">All</option>
                <option>Male</option>
                <option>Female</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Joined From</Form.Label>
              <Form.Control
                type="date"
                value={filters.fromDate}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    fromDate: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Joined To</Form.Label>
              <Form.Control
                type="date"
                value={filters.toDate}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    toDate: e.target.value,
                  })
                }
              />
            </Form.Group>

            <div className="d-flex gap-2">


              <button
                className="cancel-btn flex-fill"
                onClick={() => {
                  const resetFilters = {
                    status: "",
                    aadhaarVerified: "",
                    subscription: "",
                    gender: "",
                    fromDate: "",
                    toDate: "",
                    search: "",
                  };

                  setFilters(resetFilters);
                  setAppliedFilters(resetFilters);

                  setSearchParams({
                    page: 1,
                  });

                  setShowFilter(false);
                }}
              >
                Reset
              </button>
              <button
                className="submit-btn flex-fill"
                onClick={() => {
                  setAppliedFilters(filters);
                  setShowFilter(false);

                  updateParams({
                    page: 1,
                    searchValue: filters.search,
                    filterData: filters,
                  });
                }}
              >
                Apply
              </button>
            </div>

          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </>
  );
}
